import axios from 'axios';
import logComponent from '../logComponent';
import getConfig from './getConfig';

const Survey = (function() {
  function GetCheckInSurveyForCurrentUser() {
    if (logComponent('Survey')) { console.debug('Survey GetCheckInSurveyForCurrentUser'); }
    return axios.get('api/Survey/GetCheckInSurveyForCurrentUser', getConfig());    
  }

  function GetAllCheckInSurveysForFacility(facilityId) {
    if (logComponent('Survey')) { console.debug('Survey GetAllCheckInSurveysForFacility'); }
    const params = { facilityId };
    return axios.get('api/Survey/GetAllCheckInSurveysForFacility', getConfig(params));
  }


  function SaveResponse(surveyResponse) {
    if (logComponent('Survey')) { console.debug('Survey SaveResponse'); }
    return axios.post('api/Survey/SaveResponse', surveyResponse, getConfig());
  }

  function GetSurveyResponsesForCurrentUser(skip, take, sortOrder, searchTerms) {
    if (logComponent('Survey')) { console.debug('Survey GetSurveyResponsesForCurrentUser'); }
    let params = { skip, take, sortOrder };
    if (searchTerms) params.searchTerms = searchTerms;
    return axios.get('api/Survey/GetSurveyResponsesForCurrentUser', getConfig(params));
  }


  return {
    GetCheckInSurveyForCurrentUser,
    GetAllCheckInSurveysForFacility,
    SaveResponse,
    GetSurveyResponsesForCurrentUser
  }
})();

export default Survey;